import React, {useState} from 'react';
import {HamburgerButton} from "./HamburgerButton";

export const Menu = (props) => {
    const [show, setShow] = useState(false);

    return (
        <>
            {
                show && (
                    <div
                        className="menuTouchOutsideSensor touchOutsideSensor"
                        onClick={() => setShow(false)}
                    />
                )
            }
            <button
                className={'roundButton main menuButton fix top10 right10'}
                onClick={() => setShow(!show)}
            >
                <HamburgerButton
                    open={show}
                    transitionTime={400}
                />
            </button>
            <div
                className={`menu main${show ? ' show' : ''}`}
                onClick={(e) =>
                    e.target.tagName === 'A' && setShow(false)
                }
            >
                {props.children}
            </div>
        </>
    );
}